import { BRAND } from "../constants/brand";
import PageHero from "../components/PageHero";

const NEWS_ITEMS = [
  {
    date: "May 15, 2026",
    title: "What Does the Name Labarium Mean?",
    tag: "Company",
    excerpt: "The name Labarium is not invented — it is recovered. Drawn from one of the most consequential moments in Western history, every element of this brand carries deliberate meaning. Nothing is decorative. Everything signifies.",
    page: "labarium-origin",
  },
  // { date: "September 23, 2025", title: "Q3 2025 Newsletter", tag: "Newsletter", excerpt: "...", href: "/Q3_newsletter.pdf" },
  // { date: "May 5, 2025", title: "Q1 2025 Newsletter", tag: "Newsletter", excerpt: "...", href: "/Q1_newsletter_2025.pdf" },
  // { date: "June 19, 2024", title: "Employees Are Cheating on Workplace Drug Tests...", tag: "Industry", excerpt: "...", href: "https://fortune.com/..." },
];

const SOCIAL_LINKS = [
  {
    platform: "LinkedIn",
    handle: "@labarium",
    href: "https://www.linkedin.com/company/labarium/",
    color: "#0077B5",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
        <circle cx="4" cy="4" r="2"/>
      </svg>
    ),
  },
  {
    platform: "Facebook",
    handle: "@labarium",
    href: "https://www.facebook.com/labarium",
    color: "#1877F2",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
      </svg>
    ),
  },
  {
    platform: "Instagram",
    handle: "@labarium",
    href: "https://www.instagram.com",
    color: "#E1306C",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
        <circle cx="12" cy="12" r="5"/>
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
      </svg>
    ),
  },
];

export default function NewsroomPage({ setPage }) {
  return (
    <>
      <PageHero
        eyebrow="COMPANY"
        title="News &"
        highlight="Newsroom"
        subtitle="The latest updates, newsletters, and industry insights from Labarium Diagnostic Systems."
      />

      {/* News Articles */}
      <section className="rx-pad" style={{ background: BRAND.offWhite, padding: "80px 40px" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto" }}>

          <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: 52, flexWrap: "wrap", gap: 20 }}>
            <div>
              <div className="reveal" style={{ display: "inline-flex", alignItems: "center", gap: 14, marginBottom: 12 }}>
                <div style={{ width: 40, height: 1, background: BRAND.gold }} />
                <span style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.28em", color: BRAND.gold, textTransform: "uppercase" }}>Latest Stories</span>
              </div>
              <h2 className="reveal delay-100" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: "clamp(26px,3.5vw,42px)", color: BRAND.navy, margin: 0 }}>
                News &amp; Updates
              </h2>
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(360px, 1fr))", gap: 28, marginBottom: 80 }}>
            {NEWS_ITEMS.map((item, i) => {
              const cardStyle = {
                background: BRAND.white, borderRadius: 20,
                border: `1px solid ${BRAND.lightGray}`, overflow: "hidden",
                cursor: "pointer", transition: "all 0.35s cubic-bezier(.4,0,.2,1)",
                textDecoration: "none", display: "block",
              };
              const onEnter = e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "0 20px 56px rgba(0,30,80,0.13)"; e.currentTarget.style.borderColor = "rgba(201,169,110,0.3)"; };
              const onLeave = e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.borderColor = BRAND.lightGray; };
              const cardInner = (
                <>
                  <div style={{ background: `linear-gradient(150deg, ${BRAND.navyDeep}, ${BRAND.navyDark})`, padding: "28px 32px 24px", position: "relative", overflow: "hidden" }}>
                    <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg, ${BRAND.gold}, rgba(201,169,110,0.2))` }} />
                    <div style={{ position: "absolute", bottom: -20, right: -20, width: 100, height: 100, borderRadius: "50%", background: "rgba(201,169,110,0.04)" }} />
                    <span style={{ display: "inline-block", background: "rgba(201,169,110,0.15)", color: BRAND.gold, fontFamily: "'Inter', sans-serif", fontSize: 10, fontWeight: 600, letterSpacing: "0.2em", padding: "4px 12px", borderRadius: 6, marginBottom: 12, textTransform: "uppercase", border: "1px solid rgba(201,169,110,0.25)" }}>
                      {item.tag}
                    </span>
                    <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, color: "rgba(255,255,255,0.4)", fontWeight: 400 }}>{item.date}</div>
                  </div>
                  <div style={{ padding: "28px 32px 32px" }}>
                    <h3 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 600, fontSize: 18, color: BRAND.navy, lineHeight: 1.5, margin: "0 0 14px" }}>{item.title}</h3>
                    <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 13, color: BRAND.textMid, lineHeight: 1.75, margin: "0 0 20px" }}>{item.excerpt}</p>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ fontFamily: "'Inter', sans-serif", fontSize: 12, fontWeight: 600, color: BRAND.gold, letterSpacing: "0.08em" }}>Read More</span>
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7h10M8 3l4 4-4 4" stroke={BRAND.gold} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </div>
                  </div>
                </>
              );
              return item.page ? (
                <div key={i} className={`reveal delay-${(i + 1) * 100}`} style={cardStyle} onMouseEnter={onEnter} onMouseLeave={onLeave} onClick={() => setPage && setPage(item.page)}>
                  {cardInner}
                </div>
              ) : (
                <a key={i} href={item.href} target="_blank" rel="noreferrer" className={`reveal delay-${(i + 1) * 100}`} style={cardStyle} onMouseEnter={onEnter} onMouseLeave={onLeave}>
                  {cardInner}
                </a>
              );
            })}
          </div>

          {/* Social section */}
          <div style={{
            background: `linear-gradient(150deg, ${BRAND.navyDeep}, ${BRAND.navyDark})`,
            borderRadius: 24,
            padding: "60px 48px",
            position: "relative", overflow: "hidden",
            textAlign: "center",
          }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg, transparent, ${BRAND.gold}, transparent)` }} />
            <div style={{ position: "absolute", top: -80, right: -80, width: 320, height: 320, borderRadius: "50%", background: "radial-gradient(circle, rgba(201,169,110,0.06) 0%, transparent 65%)", pointerEvents: "none" }} />

            <div style={{ position: "relative", zIndex: 1 }}>
              <div style={{ display: "inline-flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
                <div style={{ width: 36, height: 1, background: BRAND.gold }} />
                <span style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.28em", color: BRAND.gold, textTransform: "uppercase" }}>Follow Us</span>
                <div style={{ width: 36, height: 1, background: BRAND.gold }} />
              </div>
              <h2 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: "clamp(24px,3vw,38px)", color: BRAND.white, margin: "0 0 12px" }}>
                Stay Connected on Social
              </h2>
              <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 14, color: "rgba(255,255,255,0.5)", margin: "0 auto 44px", maxWidth: 480, lineHeight: 1.75 }}>
                Follow us for industry insights, company updates, and laboratory health tips.
              </p>

              <div style={{ display: "flex", gap: 20, justifyContent: "center", flexWrap: "wrap" }}>
                {SOCIAL_LINKS.map(s => (
                  <a
                    key={s.platform}
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      display: "flex", alignItems: "center", gap: 14,
                      background: "rgba(255,255,255,0.05)",
                      backdropFilter: "blur(16px)",
                      border: "1px solid rgba(255,255,255,0.1)",
                      borderRadius: 14,
                      padding: "18px 28px",
                      textDecoration: "none",
                      transition: "all 0.25s ease",
                      minWidth: 200,
                    }}
                    onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.09)"; e.currentTarget.style.borderColor = "rgba(201,169,110,0.3)"; e.currentTarget.style.transform = "translateY(-3px)"; }}
                    onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.05)"; e.currentTarget.style.borderColor = "rgba(255,255,255,0.1)"; e.currentTarget.style.transform = "none"; }}
                  >
                    <div style={{
                      width: 44, height: 44, borderRadius: 12,
                      background: "rgba(255,255,255,0.08)",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      color: BRAND.gold,
                    }}>
                      {s.icon}
                    </div>
                    <div style={{ textAlign: "left" }}>
                      <div style={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: 14, color: BRAND.white }}>{s.platform}</div>
                      <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.4)", marginTop: 2 }}>{s.handle}</div>
                    </div>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ marginLeft: "auto", color: "rgba(255,255,255,0.3)" }}>
                      <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
